import React, {useEffect, useState} from 'react'
import {getAgentHelloMessage} from './AgentHelloMessage'
import {normalizeDateTime, transformToMessageTime, transformURLToLinkInText} from '@/utils/transformers'
import {PrescriptionMessage} from './PrescriptionMessage'
import {ImmunizationMessage} from './ImmunizationMessage'
import {NurseAdviceMessage} from './NurseAdviceMessage'
import {CustomerInfoMessage} from './CustomerInfoMessage'
import {AgentTransferNoteMessage} from './AgentTransferNoteMessage'
import {CustomerAttributesMessage} from './CustomerAttributesMessage'
import {GLPMessage} from './GLPMessage'
import { Agent0D365AttributesMessage } from './Agent0D365AttributesMessage'
import CustomDivider from "@/components/common/CustomDivider/CustomDivider";

import TranslateIconImage from "@/assets/icons/translate.png";
import {Oval as LoaderOval} from "react-loader-spinner";
import {getLanguageNameByCode} from "../../utils/translation";

const Message = (props) => {
    const {contact, currentContact, message, showTime, translationsEnabled, translationInfo} = props
    const [content, setContent] = useState(message.Content)
    const [role, setRole] = useState('system')
    const [showTranslationsDivider, setShowTranslationsDivider] = useState(false);

    let prescription = message.prescriptionRefillRequest
    let immunization = message.immunizationRequest
    let nurseAdvice = message.nurseAdviceRequest
    let glp = message.glpRequest
    let agentTransferNote = message.agentTransferNote || {}

    const getTranslatedMessage = () => {
        let result = '';
        const msgTr = message.Translation || {};
        if (message.ParticipantRole === 'AGENT') {
            result = translationInfo?.translateView ? msgTr.source : msgTr.result;
        } else if (message.ParticipantRole === 'CUSTOMER') {
            result = translationInfo?.translateView ? msgTr.result : msgTr.source;
        }
        return result ? result : content;
    }

    useEffect(() => {
        // Установка роли на основе ParticipantRole
        switch (message.ParticipantRole) {
            case 'AGENT':
                setRole('sender')
                break
            case 'CUSTOMER':
                setRole('receiver')
                break
            default:
                setRole('system')
                break
        }
    }, [message.ParticipantRole])

    useEffect(() => {
        let messageJson
        if (message.DisplayName === 'BOT' || message.DisplayName === 'SYSTEM_MESSAGE') {
            try {
                messageJson = JSON.parse(message.Content)
                setContent(messageJson.title)
            } catch (e) {
            }
        }

        if (content === 'START_CHAT') {
            setContent('Start Chat')
        } else if (message.Type === 'EVENT' && message.ContentType === 'application/vnd.amazonaws.connect.event.chat.ended') {
            setContent('Chat ended')
        } else if (message.Type === 'EVENT' && message.ParticipantRole === 'AGENT' && message.ContentType === 'application/vnd.amazonaws.connect.event.participant.joined') {
            const contentAgentHelloMessage = getAgentHelloMessage({
                contact: contact,
                message: message,
                prescription: prescription,
                immunization: immunization,
                showTransferMessage: props.showTransferMessage,
            })
            setShowTranslationsDivider(translationsEnabled);
            setContent(contentAgentHelloMessage)
        }
        else if (messageJson && messageJson.type === 'EVENT') {
            try {
                if (!message.referralInfoShown
                    && messageJson.additionalData
                    && !messageJson.customerName
                    && !messageJson.customerDOB
                ) {
                    setContent('')
                    setRole('receiver')
                    const {mrn, department, ref, token, queue} = messageJson.additionalData
                    if (mrn) {
                        setContent(prevContent => prevContent + 'Patient MRN: ' + mrn + ' <br/>')
                    }
                    if (department) {
                        setContent(prevContent => prevContent + 'Appointment department: ' + department + ' <br/>')
                    }
                    if (ref) {
                        setContent(prevContent => prevContent + 'Patient referral number: ' + ref + ' <br/> ')
                    }
                    if (token) {
                        props.setToken(token)
                        if (contact) {
                            const {
                                patientMrn,
                                patientFullName,
                                referralTeam,
                                referralExtId
                            } = JSON.parse(contact?.attributes?.additionalData.value)
                            if (patientMrn) {
                                setContent(prevContent => prevContent + 'Patient MRN: ' + patientMrn + ' ' + token + ' <br/>' + '\n')
                            }
                            if (queue) {
                                setContent(prevContent => prevContent + 'Appointment department: ' + queue + ' <br/>')
                            }
                            if (patientFullName) {
                                setContent(prevContent => prevContent + 'Patient referral full name: ' + patientFullName + ' <br/> ')
                            }
                            if (referralTeam) {
                                setContent(prevContent => prevContent + 'Patient referral team: ' + referralTeam + ' <br/> ')
                            }
                            if (referralExtId) {
                                setContent(prevContent => prevContent + 'Patient referral extended id: ' + referralExtId + ' <br/> ')
                            }
                        }
                    }
                }
            } catch (e) {
            }
        }

        if (content) {
            setContent(prev => {
                return Array.isArray(prev) ? prev.join('<br/><br/>').toString() : prev?.toString()
            })

            if (content.includes('[!]')) {
                setContent(prev => prev.replace('[!]', '<br/><br/>'))
            }
            //Replace new line characters with line breaks
            if (content.includes('\n')) {
                setContent(prev => prev.replace(/\n/g, '<br>'))
            }
            // check Back action
            if (content.indexOf('sys_back:') === 0) {
                const sysBack = content.split(':')
                setContent('(Go Back) ' + sysBack[2])
            }

            setContent(prev => transformURLToLinkInText(prev))
        }

    }, [message, content, contact, props.showTransferMessage, currentContact, props.setToken])

    const messageTime = transformToMessageTime(normalizeDateTime(message.AbsoluteTime))

    if (!content && Object.keys(agentTransferNote).length === 0) {
        return ''
    }

    const showTranslationLoading = message.Translation?.loading === true;
    const showTranslation = message.Translation && !showTranslationLoading
        && (message.ParticipantRole === 'AGENT' ? !translationInfo?.translateView : translationInfo?.translateView);

    const TranslateIcon = () => {
        let result = <></>;

        if (showTranslationLoading) {
            result = <div style={{position: 'absolute', margin: '3px'}}>
                <LoaderOval
                    color="#B1203D"
                    height={12}
                    width={12}
                    strokeWidth={10}
                    timeout={0}
                />
            </div>;
        } else if (message.Content && showTranslation) {
            result = <img src={TranslateIconImage}
                          width={12}
                          style={{position: 'absolute', margin: '3px'}}
                          alt={'Translated'}
                          title={'Translated'}
            />
        }

        return result;
    }

    return (<>
            {showTranslationsDivider &&
                <CustomDivider
                    labeled={true}
                    label={'Translation (' + getLanguageNameByCode(translationInfo?.customerLanguage) + ')'}
                />
            }
            {content && (
                role === 'receiver' ?
                    <div className={`row message-left ${showTranslation ? 'translated' : ''}`}>
                        <div className="col-md-9">
                            <TranslateIcon />
                            <p
                                dangerouslySetInnerHTML={{__html: getTranslatedMessage() /*messageHtml*/}}
                                title={messageTime}
                            />
                            <span className={'message-time ' + (showTime ? '' : 'd-none')}>
                                {messageTime}
                            </span>
                        </div>
                        <div className="col-md-3">
                        </div>
                    </div>
                    :
                    <div className={`row message-right ${showTranslation ? 'translated' : ''}`}>
                        <div className="col-md-3">
                        </div>
                        <div className="col-md-9 text-right">
                            <TranslateIcon />
                            <p
                                dangerouslySetInnerHTML={{__html: getTranslatedMessage() /*messageHtml*/}}
                                title={messageTime}
                            />
                            <span className={'message-time ' + (showTime ? '' : 'd-none')}>
                                {/*<TranslateButton />*/}
                                {messageTime}
                            </span>
                        </div>
                    </div>
            )}
            {
                message.customerInfo
                && !prescription
                && !immunization
                && !nurseAdvice ? <CustomerInfoMessage
                    data={message.customerInfo} messageTime={messageTime}/> : ''
            }
            {
                message.getContactDataAttributes ?
                    <CustomerAttributesMessage
                        getContactDataAttributes={message?.getContactDataAttributes}
                        messageTime={messageTime}/> : ''
            }
            {
                message.contactAgent0D365Attributes ?
                    <Agent0D365AttributesMessage contactAgent0D365Attributes={message?.contactAgent0D365Attributes} /> : ''
            }
            {
                prescription ? <PrescriptionMessage data={prescription} messageTime={messageTime}/> : ''
            }
            {
                immunization ? <ImmunizationMessage data={immunization} messageTime={messageTime}/> : ''
            }
            {
                nurseAdvice ? <NurseAdviceMessage data={nurseAdvice} messageTime={messageTime}/> : ''
            }
            {
                glp ? <GLPMessage data={glp} messageTime={messageTime}/> : ''
            }
            {
                agentTransferNote ? <AgentTransferNoteMessage note={agentTransferNote} messageTime={messageTime}/> : ''
            }
        </>
    )
}

export default Message
